var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleTransferRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2913_4159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 15.1667C7.21984 15.1667 6.49318 14.8667 5.94651 14.32L1.6865 10.06C1.13984 9.51335 0.839844 8.78001 0.839844 8.00667C0.839844 7.23334 1.13984 6.5 1.6865 5.95333L5.94651 1.69332C6.49318 1.14665 7.2265 0.84668 7.99984 0.84668C8.77317 0.84668 9.5065 1.14665 10.0532 1.69332L14.3132 5.95333C14.8598 6.5 15.1598 7.23334 15.1598 8.00667C15.1598 8.78001 14.8598 9.51335 14.3132 10.06L10.0532 14.32C9.5065 14.8667 8.77984 15.1667 7.99984 15.1667ZM7.99984 1.83333C7.4865 1.83333 7.00651 2.03334 6.65318 2.38668L2.39317 6.64665C2.03317 7.00665 1.83984 7.48666 1.83984 7.99333C1.83984 8.49999 2.03983 8.98667 2.39317 9.34001L6.65318 13.6C7.36651 14.3134 8.63316 14.3134 9.3465 13.6L13.6065 9.34001C13.9665 8.98001 14.1598 8.50666 14.1598 7.99333C14.1598 7.47999 13.9598 6.99998 13.6065 6.64665L9.3465 2.38668C8.99316 2.03334 8.51317 1.83333 7.99984 1.83333Z",
    fill: "#E61B17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2913_4159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleTransferRed);
export default __webpack_public_path__ + "static/media/single-transfer-red.47f817fb5bcd0749ffde6026f78e7795.svg";
export { ForwardRef as ReactComponent };